import styled from "@emotion/styled";
import { Box } from "rebass";
import Img from "gatsby-image";

export const Wrapper = styled(Box)`
  padding-top: 4.5rem;

  ${({ theme }) => theme.mq.md`
    padding-top: 12rem;
  `}
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const Image = styled(Img)`
  background-color: ${({ theme }) => theme.colors.primary}29;
  border-radius: 2rem;
  height: ${({ height }) => height}px;
  object-fit: cover;
  overflow: hidden;
  width: 100%;

  ${({ theme }) => theme.mq.sm`
  max-height: 50rem;
  `}

  ${({ theme }) => theme.mq.md`
  max-height: 57rem;
  `}
`;
